export default "__VITE_ASSET__CZc2eege__"